import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { DocItemExportFileContainerModel } from "../../../../../../models/aggregates/erp/doc-item-link-export/doc-item-export-container.model";

@Injectable({ providedIn: "root" })
export class DocItemPricingExportService extends BaseApiTemplateService<DocItemExportFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "fi-items/export/csvs/doc-item-pricing-file-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "fi-items/export/csvs/doc-item-pricing-file-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}
